import { createStore, combineReducers, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { routerReducer, routerMiddleware } from 'react-router-redux'
import { gettersMiddleware } from 'react-redux-getters'
import { appProgressReducer } from 'atoms/AppProgress'
import { appSavingReducer } from 'atoms/AppSaving'
import { appSnackbarReducer } from 'atoms/AppSnackbar'
import { unlockFeatureDialogReducer } from 'components/Billing/UnlockFeatureDialog'
import api from 'utils/api'
import * as reducers from './reducers'

export default (history, ...middlewares) => {
  const createReducer = () => combineReducers({
    appProgress: appProgressReducer,
    appSaving: appSavingReducer,
    appSnackbar: appSnackbarReducer,
    unlockFeatureDialog: unlockFeatureDialogReducer,
    router: routerReducer,
    ...reducers,
  })

  const store = createStore(
    createReducer(),
    applyMiddleware(
      thunk.withExtraArgument((...args) => api(store)(...args)),
      routerMiddleware(history),
      gettersMiddleware,
      ...middlewares,
    )
  )

  if (module.hot) {
    module.hot.accept('./reducers', () => store.replaceReducer(createReducer()))
  }

  return store
}
